export default {
  getTableListing (cb, errorCb) {
    axios.get('/table')
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },

  getGameConfig (tableId, cb, errorCb) {
    axios.get('/table/' + tableId)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },

  getGameConfigWithInformation (tableId, cb, errorCb) {
    axios.get(`/table/${tableId}?include=dealer,info`)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/hilolocal/api/game.js